import React from 'react';

const ShimmerEffect = () => {
  return (
	<>
		<div class="container-shimmer">
			<div class="box-shimmer"><div className="shimmer-div"></div></div>
			<div class="box-shimmer"><div className="shimmer-div"></div></div>
			<div class="box-shimmer"><div className="shimmer-div"></div></div>
		</div>

		<div class="container-shimmer">
			<div class="box-shimmer mar-top-0"><div className="shimmer-div"></div></div>
		</div>
	</>
  );
};

export default ShimmerEffect;